import React, { FC } from 'react';
import { Outbound } from 'ts/flight/interfaces/FlightSearch';
import { getLogoUrl, getDaysDifference } from 'utils/utils';
import { getElapsedStr } from 'utils/flight/flight';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faInfoCircle, faPlane } from '@fortawesome/free-solid-svg-icons';
import Tooltip from 'components/ui/Tooltip/Tooltip';
import TicketRouteTime from './TicketRouteTime';
import { HighlightRoute } from 'ts/flight/interfaces/HighlightRoute';
import { useTranslation } from 'react-i18next';
import TicketRouteBaggage from './TicketRouteBaggage';
import withErrorBoundary from 'components/shared/withErrorBoundary';
import { blobUrl } from 'constants/generic';

interface TicketRouteProps {
  outbond: Outbound;
  highlighted?: HighlightRoute;
  setOpen: () => void;
  firstRoute: boolean;
  choose: () => void;
}

const TicketRoute: FC<TicketRouteProps> = ({ outbond, highlighted, setOpen, ...props }) => {
  const [t] = useTranslation();
  
  const stops = outbond.legCount - 1;

  const arrivalDaysDifference = getDaysDifference(
    outbond.departureDateTime,
    outbond.arrivalDateTime
  );

  return (
    <div className="ticket-route ticket-route-short">
      <span className="ticket-airline">
        <img src={getLogoUrl(blobUrl, outbond.airline.code)} alt={outbond.airline.desc} />
      </span>
      <div className="ticket-data">
        <TicketRouteTime
          dateTime={outbond.departureDateTime}
          airportDesc={outbond.departureAirport.desc}
          airport={outbond.departureAirport.code}
          highlighted={highlighted?.departure}
          isShort={true}
        />
        <div className="ticket-directions">
          <span className="stops-duration">{getElapsedStr(t, outbond.elapsedDTime)}</span>
          <span className="line">
            <FontAwesomeIcon icon={faPlane as any} />
            {stops === 0 && (
              <span className="flight-direct-title">{t('filter.direct_flight')}</span>
            )}
            {stops === 1 && <span className="circle">1 {t('filter.stop')}</span>}
            {stops > 1 && (
              <span className="circle">
                {stops} {t('filter.stops')}
              </span>
            )}
          </span>

          {props.firstRoute && (
            <span onClick={() => setOpen()} className="text-center mt-10">
              <Tooltip
                content={t('flight.details_segment')}
                children={
                  <FontAwesomeIcon
                    icon={faInfoCircle as any}
                    className="text-contrast cur-poi"
                    size="lg"
                  />
                }
              />
            </span>
          )}
        </div>

        <TicketRouteTime
          dateTime={outbond.arrivalDateTime}
          airportDesc={outbond.arrivalAirport.desc}
          airport={outbond.arrivalAirport.code}
          arrivalDaysDifference={arrivalDaysDifference}
          highlighted={highlighted?.arrival}
          isShort={true}
        />
      </div>
      <TicketRouteBaggage outbond={outbond} choose={props.choose} />
    </div>
  );
};

export default withErrorBoundary(TicketRoute, 'TicketRoute');
